function sessionCreatedAtMs(sess) {
  const raw = sess?.createdAt ?? sess?.created_at;
  return raw ? new Date(raw).getTime() : null;
}

function isSyntheticPastSession(sess) {
  if (!sess?.end_datetime) return false;
  const created = sessionCreatedAtMs(sess);
  if (!created) return false;
  return created > new Date(sess.end_datetime).getTime();
}

/** Текущее или ещё не завершившееся занятие. */
export function isUpcomingOrLiveSession(sess) {
  if (isSyntheticPastSession(sess)) return false;
  if (!sess?.end_datetime) return true;
  return new Date(sess.end_datetime).getTime() >= Date.now();
}

/** Ближайшие занятия на главной — без уже прошедших. */
export function filterHomeSessions(sessions) {
  return (sessions || [])
    .filter((sess) => sess.status !== "cancelled" && sess.status !== "completed")
    .filter(isUpcomingOrLiveSession)
    .sort(
      (a, b) =>
        new Date(a.start_datetime).getTime() -
        new Date(b.start_datetime).getTime(),
    )
    .slice(0, 8);
}
